import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import { RequiredPayloadFieldIsNotProvided } from '@savgroup-front-common/exceptions';
import { BaseBackResponse } from '@savgroup-front-common/types';

const URL = `${APIConfiguration.claim}orders/${COMMON_QUERY_PARAMS.ORDER_ID}/claims`;

interface Claim {
  groupId: string;
  claimId: string;
  orderLineReference: string;
  state: string;
  ownerProductId: string;
  claimCreationDateUtc: string;
}

interface Response extends BaseBackResponse {
  value: Claim[];
}

export interface GetClaimsByOrderIdArgs {
  orderId: string;
}

export const getClaimsByOrderIdRequest = (
  payload: GetClaimsByOrderIdArgs,
): ApiRequestDescriptor => ({
  url: URL.replace(COMMON_QUERY_PARAMS.ORDER_ID, payload.orderId),
  config: { method: SUPPORTED_METHODS.GET },
});

async function getClaimsByOrderId({
  orderId,
}: GetClaimsByOrderIdArgs): Promise<Claim[]> {
  if (!orderId) {
    throw new RequiredPayloadFieldIsNotProvided(
      'products',
      `getClaimsByOrderId`,
    );
  }

  const response = await executeQuery<Response>(
    getClaimsByOrderIdRequest({ orderId }),
  );

  return response.value;
}

export default getClaimsByOrderId;
